import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { UtilityService } from './utility.service';
import { environment } from '../../environments/environment';


@Injectable()
export class StorageService {
	constructor(
		private cookie: CookieService,
		private utility: UtilityService
	) {

	}


	get(key: string, useLocal?: boolean) {
		useLocal = useLocal || false;
		if (useLocal) {
			return  JSON.parse(localStorage.getItem(key) || 'null');
		} else {
			const value = this.cookie.get(key);
			try {
				return JSON.parse(value);
			} catch {
				return value;
			}
		}
	}

	set(key: string, value: any, useLocal?: boolean, minutesToExpire = 60 * 24 * 100) {

		useLocal = useLocal || false;
		if (useLocal) {
			return localStorage.setItem(key, JSON.stringify(value));
		} else {
			let expiry = new Date();
			expiry.setMinutes(expiry.getMinutes() + minutesToExpire);
			const subDomain = UtilityService.getSubdomain();

			if (subDomain && subDomain === 'canada') {
				//sso authorization is the only case where cookie values need to jump
				//between several subdomains.
				//This condition is specifically for that use case but will be expanded
				//with other integrations
				this.cookie.set(key, value, { secure: environment.production, expires: expiry, domain: '.' + 'welltrack.com' });
			}
			else {
				this.cookie.set(key, value, { secure: environment.production, expires: expiry });
			}
			return true;
		}
	}

	checkFlag(flag: string) {
		let flags = JSON.parse(localStorage.getItem('flags') || "{}");

		return flags[flag];
	}


	setFlag(flag: string) {
		//get existing flags

		let flags = JSON.parse(localStorage.getItem('flags') || "{}");
		flags[flag] = true;
		localStorage.setItem('flags', JSON.stringify(flags));

		return flags[flag];
	}

	checkReminder(reminder: string) {

		const reminderStr:string = JSON.parse(localStorage.getItem(reminder) || 'null');
		const decodedFlag = JSON.parse(reminderStr);
		const now = new Date();
		if(decodedFlag){
			if(now.getTime() > decodedFlag.expiry){
				return false;
			}
		}
		localStorage.removeItem(reminder);
		return true;
	}

	setReminder(reminder: string, daysToExpire = 100) {

		const now = new Date()

		// `item` is an object which contains the original value
		// as well as the time when it's supposed to expire
		now.setDate(now.getDate() + daysToExpire);
		const item = {
			value: true,
			expiry: now.getTime(),
		}
		localStorage.setItem(reminder, JSON.stringify(item))
	}

	clearAllCookies() {
		this.cookie.deleteAll();
		this.cookie.deleteAll('/', '.welltrack.com');
	}

	clearLogin() {
		 const keys = ['user', 'isAuthenticated', 'accessToken', 'fcmToken'];
			keys.forEach(key => {
			localStorage.removeItem(key);
			this.cookie.delete(key);
			});
	}

	resetFlags() {
		localStorage.removeItem('flags');
	}
}
